export const addMethodologyEvents = d => {
    const methodology = document.getElementById('methodology');
    const methodology_box = document.getElementById('methodology-box');
    methodology.addEventListener('click', event => {
      if (methodology_box.className === 'show') {
          methodology_box.className = "";
          methodology.className = "";
      } else {
          methodology_box.className = "show";
          methodology.className = "show";
      }
    });
}
